export default "__VITE_ASSET__DkRo0eoy__"